import { createSlice } from '@reduxjs/toolkit';

export interface IChatsReducer {
  chat: {
    isChanged: boolean;
    isLoading: boolean;
    lastSavedAt: string | null;
    lastSavedChatbotId: string | null;
  };
}

const initialState: IChatsReducer = {
  chat: {
    isChanged: false,
    isLoading: false,
    lastSavedAt: null,
    lastSavedChatbotId: null,
  }
};

export const chatsSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    setChatChanged: (state, action) => {
      state.chat.isChanged = action.payload;
    },
    setIsLoading: (state, action) => {
      state.chat.isLoading = action.payload;
    },
    setLastSaved: (state, action: { payload: { updatedAt: string; chatbotId: string } }) => {
      state.chat.lastSavedAt = action.payload.updatedAt;
      state.chat.lastSavedChatbotId = action.payload.chatbotId;
    },
  },
});

export const { setChatChanged, setIsLoading, setLastSaved } = chatsSlice.actions;
